<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="modal-title">
                                    <span v-if="id">Edit Zone</span>
                                    <span v-else>Add Zone</span>
                                    <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg}'>
                                        <font-awesome-icon icon="times" aria-hidden="false" />
                                    </div>
                                </div>
                                <form method="post" enctype="multipart/form-data" @submit.prevent="submitForm" :class="{isTpg:isTpg}" name="zone_form" style="height:100%">
                                    <div class="onboarding-container" :class='{isTpg: isTpg}' id="formTopping">

                                        <reload-page v-if="showReload" :showReloadMessage="showReloadMessage" style="margin-top:50px;" id="reload-component"></reload-page>

                                        <fieldset>
                                            <div class="row">
                                                <div class="col-lg-4" :class="{inlineError:v$.name.$error,isTpg:isTpg}">
                                                    Zone Name: *
                                                </div>
                                                <div class="col-lg-8">
                                                    <input type="text" name="Zone Name" id="location_zone_name" v-model="name" placeholder="e.g. Bar, Dining Room">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    Playlist Hours: *
                                                </div>
                                                <div class="col-lg-8">
                                                    <div v-for="day in hours" :key="day.day_id">
                                                        <div class="hours-row">

                                                            <div class="copyToAllSmall" v-if="day.day_id == '1'" >
                                                                 <!-- <Popper content="Copy Sunday's times to the rest of the week" hover z-index="103" > -->
                                                                    <font-awesome-icon icon="paste" @click="copyToAll"  aria-hidden="false" title="Copy Sunday's times to the rest of the week" />
                                                                 <!-- </Popper> -->

                                                            </div>
                                                            <div class="col-xs-6">
                                                                <div class="col-xs-3 day-name">
                                                                    {{ getDayName(day.day_id) }}
                                                                </div>
                                                                <div class="col-xs-9">
                                                                    <vue-select close-on-select class="" v-model="day.open_time" :options="timeOptions" autocomplete="false" :clearable="false"></vue-select>
                                                                </div>
                                                            </div>
                                                            <div class="col-xs-6">
                                                                <div class="col-xs-3">
                                                                    &nbsp;&nbsp;to
                                                                </div>
                                                                <div class="col-xs-9">
                                                                    <vue-select close-on-select class="" v-model="day.close_time" :options="timeOptions" autocomplete="false" :clearable="false"></vue-select>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <fieldset>

                                                <div class="section-header">
                                                    Music Setup
                                                </div>

                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="form-blurb" :class="{isTpg:isTpg}">
                                                            Please tell us when you'd like to start the music service on this zone. It typically take us about 2 weeks to get your music set up, if you need it faster there is a $75 rush charge. Please check RUSH. This does not include shipping charges (US ground
                                                            is $15 and Overnight is $50).
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-lg-4">
                                                        RUSH:
                                                    </div>
                                                    <div class="col-lg-8">
                                                        <input type="checkbox" name="rush_order" id="rush_order" class="checkbox" v-model="expedite" :class="{isTpg:isTpg}">
                                                    </div>
                                                </div>

                                                <div>

                                                    <div class="row">
                                                        <div class="col-lg-4" :class="{isTpg:isTpg}">
                                                            Player Arrival Date: *
                                                        </div>
                                                        <div class="col-lg-8 date-picker">
                                                            <datepicker :lowerLimit="disabledPastDates.to" :upperLimit="disabledPastDates.from" name="Player Arrival Date" placeholder="MM/DD/YYYY" class="datepicker" inputFormat="MM/dd/yyyy" v-model="player_arrival_date" :use-utc="false" style="border:0px solid #ccc;" :disabledDtes="disabledPastDates"></datepicker>
                                                            <!--  -->
                                                        </div>
                                                    </div>

                                                </div>
                                                <!-- <div class="row" v-tooltip="'We do not prorate, if your arrival date is the 1-15th of the month FMOS is the current month, if it is the 16-EOM it is the next month.'">
                                                    <div class="col-lg-4">
                                                        First Month of Service:
                                                    </div>
                                                    <div class="col-lg-8 ">
                                                        <span >{{ first_month_of_service_string }}</span>
                                                    </div>
                                                </div> -->
                                            </fieldset>

                                            <fieldset>

                                                <div class="section-header">
                                                    Player Setup
                                                </div>
                                                <div class="form-group workspace-content-form-row row" style="padding-top:10px;">
                                                    <div class="col-lg-3">
                                                        Player Type:
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <span v-if="player_type_id == 1" style="">
                                                        Physical
                                                    </span>
                                                        <span v-if="player_type_id == 2">
                                                        Virtual
                                                    </span>
                                                        <span v-if="player_type_id == 3">
                                                        Mobile
                                                    </span>

                                                    <span style="padding-left:0px;float:left;" >
                                                        <!-- <Popper content="Please contact us if you wish to use a software player." hover=true z-index="100" style="float:left;"> -->
                                                            <font-awesome-icon icon="info-circle"  v-if="player_type_id == 1" aria-hidden="false" title="Please contact us if you wish to use a software player." />&nbsp;&nbsp;
                                                        <!-- </Popper> -->
                                                    </span>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-lg-3">
                                                        Output:
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <div class="player-update-radios" style="margin-bottom:0px;margin-left:-10px;">
                                                            <div class="form-check" :class="{isTpg:isTpg}">
                                                                <label class="form-check-label">
                                                                <input class="form-check-input" :class="{isTpg:isTpg}" id="mono" type="radio" name="is_stereo" v-model="is_stereo" value="0">
                                                                Mono
                                                            </label>
                                                            </div>
                                                            <div class="form-check" :class="{isTpg:isTpg}">
                                                                <label class="form-check-label">
                                                                <input class="form-check-input" :class="{isTpg:isTpg}" id="stereo" type="radio" name="is_stereo" v-model="is_stereo"  value="1">
                                                                Stereo
                                                            </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-lg-3">

                                                    </div>
                                                    <div class="col-lg-9">
                                                        <div class="form-desc" :class="{isTpg:isTpg}">We will ship your player with a mono signal. If you know that you require a stereo signal please check 'Stereo'.</div>
                                                    </div>
                                                </div>

                                                <div class="row" v-if="player_type_id == '1'">

                                                </div>

                                                <div class="row" v-if="player_type_id == '1'" style="margin-top:15px;">
                                                    <div class="col-lg-3">
                                                        Cable Notes:
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <textarea v-model="hardware_note" rows="3" placeholder="We ship with 7 ft ethernet cables and 6 ft RCA cables.  Let us know if you need a different setup or if you do not need cables shipped."></textarea>
                                                    </div>
                                                </div>

                                                <div v-if="player_type_id == '1'">

                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            Network Type:
                                                        </div>
                                                        <div class="col-lg-9">
                                                            <div class="player-update-radios" style="margin-bottom:0px;margin-left:-10px;">
                                                                <div class="form-check" :class="{isTpg:isTpg}">
                                                                    <label class="form-check-label">
                                                                    <input class="form-check-input" :class="{isTpg:isTpg}" id="dhcp" type="radio" name="dhcp_or_static" v-model="network_configs.network_config_type_id" value="1" @click="updateDHCPStatic('1')">
                                                                    &nbsp;&nbsp;DHCP (Most common)
                                                                </label>
                                                                </div>
                                                                <div class="form-check" :class="{isTpg:isTpg}">
                                                                    <label class="form-check-label">
                                                                    <input class="form-check-input" :class="{isTpg:isTpg}" id="static" type="radio" name="dhcp_or_static" v-model="network_configs.network_config_type_id"  value="2" @click="updateDHCPStatic('2')">
                                                                    &nbsp;&nbsp;Static
                                                                </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-if="network_configs.network_config_type_id == '1'" class="dhcp">

                                                    </div>

                                                    <div v-if="network_configs.network_config_type_id == '2'" class="static">
                                                        <div class="row">
                                                            <div class="col-lg-3" :class="{isTpg:isTpg}">IP Address</div>
                                                            <div class="col-lg-9">
                                                                <input type="text" name="IP Address" id="ipaddress" v-model="network_configs.ipaddress" placeholder="e.g. 192.168.162.10">
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3" :class="{isTpg:isTpg}">Subnet</div>
                                                            <div class="col-lg-9">
                                                                <input type="text" name="Subnet" id="subnet" v-model="network_configs.subnet" placeholder="e.g. 255.255.255.0">
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3" :class="{isTpg:isTpg}">Gateway</div>
                                                            <div class="col-lg-9">
                                                                <input type="text" name="Gateway" id="gateway" v-model="network_configs.gatewayaddress" placeholder="e.g. 255.255.255.0">
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3">DNS 1</div>
                                                            <div class="col-lg-9">
                                                                <input type="text" name="dns1" id="dns1" v-model="network_configs.dns1" placeholder="e.g. www.example.com">
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3">DNS 2</div>
                                                            <div class="col-lg-9">
                                                                <input type="text" name="dns_2" id="dns2" v-model="network_configs.dns2" placeholder="e.g. www.example2.com">
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </fieldset>
                                        </fieldset>

                                        <fieldset v-if="zoneProposal && shouldHideProposal == false" id="proposal">
                                            <div class="section-header">
                                                Proposal
                                            </div>

                                            <div class="row">
                                                <iframe :src="zoneProposal.remote_path" width="600" height="300" frameborder="0" marginwidth="0" marginheight="0" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;" allowfullscreen> </iframe>
                                                <div style="text-align:center" class="row">
                                                    <a :href="zoneProposal.remote_path" target="_NEW">Open proposal in new window</a>
                                                </div>
                                            </div>

                                        </fieldset>

                                        <fieldset v-if="zoneMsa && !shouldHideMsa" id="service_agreement">
                                            <div class="section-header">
                                                Service Agreement
                                            </div>

                                            <div class="row">
                                                <iframe :src="zoneMsa.remote_path" width="600" height="300" frameborder="0" marginwidth="0" marginheight="0" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;" allowfullscreen> </iframe>
                                                <div style="text-align:center" class="row">
                                                    <a :href="zoneMsa.remote_path" target="_NEW">Open service agreement in new window</a>
                                                </div>
                                            </div>

                                            <div class="row" v-if="zoneMsa.client_document_type_id == SIGNED_MSA_ID" id="service_agreement_is_signed">
                                                <div class="col-lg-11">
                                                    This service agreement has been signed
                                                </div>
                                                <div class="col-lg-1">
                                                    <font-awesome-icon icon="check-square" aria-hidden="false" />
                                                </div>
                                            </div>

                                            <div v-else>
                                                <div class="row">
                                                    <div class="col-lg-11">
                                                        <label for="msa_agreement_checkbox" :class="{inlineError:v$.msa_is_signed.$error,isTpg:isTpg}">I have read and agree to the terms and conditions of this Service Agreement.</label>
                                                    </div>
                                                    <div class="col-lg-1">
                                                        <input type="checkbox" name="Agree to MSA" id="msa_agreement_checkbox" class="checkbox" v-model="msa_is_signed" :class="{isTpg:isTpg}">
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-3" :class="{inlineError:v$.msa_signature.$error,isTpg:isTpg}">
                                                        Signature
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <input type="text" id="msa_signature" name="MSA Signature" v-model="msa_signature" :class="{isTpg:isTpg}">
                                                    </div>
                                                </div>
                                            </div>

                                        </fieldset>

                                        <div style="width:100%;text-align:center;margin-top:30px;">
                                            <button class="clean-grayv" type="submit" style="width:300px;" :disabled="formHasBeenSubmitted">Submit</button>
                                        </div>
                                        <br><br>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Datepicker from 'vue3-datepicker';
import useVuelidate from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators';

const Querystring = require('querystring');

const DEFAULT_HOURS = [
  { day_id: '1', open_time: '10:00', close_time: '22:00' },
  { day_id: '2', open_time: '10:00', close_time: '22:00' },
  { day_id: '3', open_time: '10:00', close_time: '22:00' },
  { day_id: '4', open_time: '10:00', close_time: '22:00' },
  { day_id: '5', open_time: '10:00', close_time: '22:00' },
  { day_id: '6', open_time: '10:00', close_time: '22:00' },
  { day_id: '7', open_time: '10:00', close_time: '22:00' },
];
const DEFAULT_NETWORK_CONFIG = {
  network_config_type_id: '1',
  network_config_proxy_auth_type: null,
  ipaddress: '',
  gatewayaddress: '',
  dns1: '',
  dns2: '',
  subnet: '',
  proxy_port: '',
  proxy_user: '',
  proxy_pass: '',
};
const AUTH_TYPES = [{ network_config_proxy_auth_type_id: 1, name: 'Auto', value: '--proxy-anyauth' }, { network_config_proxy_auth_type_id: 2, name: 'NTLM', value: '--proxy-ntlm' }, { network_config_proxy_auth_type_id: 3, name: 'HTTP Basic', value: '--proxy-basic' }];
const DEFAULT_PLAYER_TYPE_ID = 1;

export default {
  props: ['is-tpg',
    'location-id',
    'location-documents',
    'user-info',
    'id',
  ],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: '',
      first_month_of_service: '',
      player_arrival_date: null,
      expedite: false,
      player_type_id: DEFAULT_PLAYER_TYPE_ID,
      is_stereo: 0,
      hardware_note: '',
      network_configs: DEFAULT_NETWORK_CONFIG,
      hours: DEFAULT_HOURS,
      days: {
        1: 'SUN', 2: 'MON', 3: 'TUE', 4: 'WED', 5: 'THU', 6: 'FRI', 7: 'SAT',
      },
      errorString: '',
      all_auth_types: AUTH_TYPES,
      msa_is_signed: false,
      showReload: false,
      showReloadMessage: '',
      shouldHideMsa: false,
      shouldHideProposal: false,
      zoneMsa: null,
      zoneProposal: null,
      msa_signature: '',
      formHasBeenSubmitted: false,
      UNSIGNED_MSA_ID: 12,
      SIGNED_MSA_ID: 13,
      PROPOSAL_ID: 14,
      HIDE_MSA_SERVICE_OPTION_ID: 30,
      HIDE_PROPOSAL_SERVICE_OPTION_ID: 31,
    };
  },
  validations() {
    return {
      name: { required: helpers.withMessage('Zone name is required', required) },
      msa_is_signed: { required: helpers.withMessage('Check to agree is required', required) },
      msa_signature: {
        required: helpers.withMessage('Signature is required', requiredIf(function () {
          return this.zoneMsa && this.msa_is_signed === false;
        })),
      },
    };
  },
  created() {

    // this.getZoneInfo();
  },
  mounted() {
    this.getZoneInfo();
  },
  methods: {
    returnFriendlyErrors(response) {
      if (!response) return;

      if (response && response.data && (response.error == 'Unauthenticated.' || response.data.error == 'Unauthenticated')) {
        window.location.reload();
      }

      let errorString = '';
      if (response) {
        if (response.data) {
          errorString += this.parseDataKeys(response.data.fields);
        }
        if (response.message) {
          errorString += response.message;
        }
      }

      return errorString;
    },
    getZoneInfo() {
      if (!this.id) {
        this.clearInfo();
        return;
      }
      const self = this;
      this.$http.get(`/v2/zone/${this.id}`).then((response) => {
        self.setZoneModel(response.data.data);
        self.getZoneHours();
        self.setMsaForZone();
        self.setProposalForZone();
      },
      (response) => {
        self.errorString = self.returnFriendlyErrors(response.data.data.fields);
        self.$wkToast(self.errorString);
      }).catch((response) => {
        if (response && response.error) {
          self.showReload = true;
          self.showReloadMessage = 'Unable to load zone.';
        }
      });
    },
    getZoneHours() {
      if (!this.id) {
        this.showReload = true;
        this.showReloadMessage = 'Unable to load zone hours.';
      }
      const self = this;
      this.$http.get(`/v1/location_zone_hours/${this.id}`).then((response) => {
        self.updateZoneHoursModel(response.data);
        self.getZoneNetworkConfig();
      },
      (response) => {
        self.errorString = self.returnFriendlyErrors(response.data.data.fields);
        self.$wkToast(self.errorString);
      }).catch(() => {
        self.showReload = true;
        self.showReloadMessage = 'Unable to load zone hours.';
      });
    },
    getZoneNetworkConfig() {
      const self = this;
      this.$http.get('/v2/network_config').then((response) => {
        const networkConfig = response.data.data.network_configs;
        const zoneId = self.id;
        if (networkConfig && networkConfig[zoneId]) {
          self.updateNetworkConfigModel(networkConfig[zoneId]);
        }
      }).catch(() => {
        self.showReload = true;
        self.showReloadMessage = 'Unable to load network configuration.';
      });
    },
    setZoneModel(response_body_data) {
      const { zone } = response_body_data;
      const { demo_signup } = response_body_data;

      if (!zone) {
        this.clearInfo();
        return;
      }

      // if (zone.id) {
      //     this.id = zone.id;
      // }

      if (zone.name) {
        this.name = zone.name;
      }

      if (demo_signup.player_arrival_date) {
        this.player_arrival_date = new Date(`${demo_signup.player_arrival_date}T16:00:00.000Z`);

        this.setFirstMonthOfService(this.player_arrival_date);
      }

      if (demo_signup && demo_signup.expedite) {
        if (demo_signup.expedite == 1) {
          this.expedite = true;
        }
      }

      if (zone.player_type_id) {
        this.player_type_id = zone.player_type_id;
      }

      if (response_body_data.is_stereo == 1) {
        this.is_stereo = 1;
      }

      if (response_body_data.hardware_note) {
        this.hardware_note = response_body_data.hardware_note.message;
      }
    },
    updateNetworkConfigModel(network_configs) {
      if (network_configs) {
        this.network_configs = network_configs;
        if (this.network_configs && this.network_configs.network_config_proxy_auth_type_id) {
          for (let i = 0; i < this.all_auth_types.length; i++) {
            if (this.all_auth_types[i].network_config_proxy_auth_type_id == this.network_configs.network_config_proxy_auth_type_id) {
              this.network_configs.network_config_proxy_auth_type = this.all_auth_types[i];
            }
          }
        }

        if (!this.network_configs.network_config_type_id) {
          this.network_configs.network_config_type_id = DEFAULT_NETWORK_CONFIG.network_config_type_id;
        }
      }
    },
    updateZoneHoursModel(zone_hours) {
      if (zone_hours) {
        const formatted_hours = [];
        for (let i = 0; i < zone_hours.length; i++) {
          const { open_time } = zone_hours[i];
          const { close_time } = zone_hours[i];
          const split_open = open_time.split(':');
          const split_close = close_time.split(':');

          const day = { day_id: i + 1, open_time: `${split_open[0]}:${split_open[1]}`, close_time: `${split_close[0]}:${split_close[1]}` };
          formatted_hours.push(day);
        }

        this.hours = formatted_hours;
      }
    },
    clearInfo() {
      // this.id = "";
      this.name = '';
      this.player_arrival_date = null;
      this.expedite = false;
      this.player_type_id = DEFAULT_PLAYER_TYPE_ID;
      this.is_stereo = 0;
      this.hardware_note = '';
      this.hours = DEFAULT_HOURS;
      this.network_configs = DEFAULT_NETWORK_CONFIG;
      this.first_month_of_service = '';
      this.errorString = '';
      this.showReload = false;
      this.showReloadMessage = '';
      // this.shouldHideMsa = false;
      // this.shouldHideProposal = false;
      this.zoneMsa = null;
      this.zoneProposal = null;
      this.msa_signature = '';
      this.msa_is_signed = false;
      this.formHasBeenSubmitted = false;
    },
    submitForm() {
      this.formHasBeenSubmitted = true;
      this.v$.$validate();
      if (!this.v$.$error) {
        const zone = {
          location_id: this.locationId,
          name: this.name,
          player_type_id: this.player_type_id,
        };

        // If edit, include zone in params
        if (this.id) {
          zone.id = this.id;
        }
        if (this.player_arrival_date) {
          zone.player_arrival_date = this.formatDate(this.player_arrival_date);
          zone.first_month_of_service = this.first_month_of_service;
        }
        if (this.expedite) {
          zone.expedite = 1;
        } else {
          zone.expedite = 0;
        }
        if (this.is_stereo == 1) {
          zone.is_stereo = 1;
        } else {
          zone.is_stereo = 0;
        }
        if (this.hardware_note) {
          zone.hardware_note = this.hardware_note;
        }

        this.formHasBeenSubmitted = false;
        this.zoneSubmitted(zone);
      } else {
        this.formHasBeenSubmitted = false;
        const errors = this.v$.$errors;
        let errorList = '<b>Errors</b><ul>';
        for (let i = 0; i < errors.length; i++) {
          errorList += `<li>${errors[i].$message}</li>`;
        }

        errorList += '</ul>';
        this.$wkToast(errorList);
      }
      // this.$validator.validateAll().then(res=>{
      //     //If successfully pass validation
      //     if(res) {

      //     } else {

      //     }
      // })
    },
    zoneSubmitted(zone) {
      this.errorString = '';
      this.formHasBeenSubmitted = false;
      if (!zone.id) {
        this.postZone(zone);
      } else {
        this.putZone(zone);
      }
    },
    postZone(zone) {
      let queryStringZone = Querystring.stringify(zone);
      const hoursString = this.makeHoursString();
      const networkString = this.makeNetworkConfigQueryString();

      queryStringZone = queryStringZone + hoursString + networkString;

      const self = this;
      this.$http.post('/v2/zone', queryStringZone).then((response) => {
        if (response.data.error == true) {
          self.errorString = response.body.message;
          self.$wkToast(self.errorString);
        } else {
          // Add id to zone object
          let new_zone_id = null;
          if (response && response.data && response.data.data && response.data.data.zone && response.data.data.zone.id) {
            new_zone_id = response.data.data.zone.id;
            zone.id = new_zone_id;
          }

          self.$emit('zoneCreated', zone);
          self.clearInfo();
          self.$emit('close');
        }
      },
      (response) => {
        self.errorString = self.returnFriendlyErrors(response.data.data.fields);
        self.$wkToast(self.errorString);
      });
    },
    makeNetworkConfigQueryString() {
      // Format network settings for JSON
      let networkString = '';
      if (this.network_configs.network_config_type_id == '2') {
        networkString += '&network[type]=static';

        if (this.network_configs.ipaddress) {
          networkString += `&network[ipaddress]=${this.network_configs.ipaddress}`;
          // zone['network']['ipaddress'] = this.network_configs.ipaddress;
        }
        if (this.network_configs.subnet) {
          networkString += `&network[subnet]=${this.network_configs.subnet}`;
          // zone['network']['subnet'] = this.network_configs.subnet;
        }
        if (this.network_configs.gatewayaddress) {
          networkString += `&network[gatewayaddress]=${this.network_configs.gatewayaddress}`;
          // zone['network']['gatewayaddress'] = this.network_configs.gatewayaddress;
        }
        if (this.network_configs.dns1) {
          networkString += `&network[dns1]=${this.network_configs.dns1}`;
          // zone['network']['dns1'] = this.network_configs.dns1;
        }
        if (this.network_configs.dns2) {
          networkString += `&network[dns2]=${this.network_configs.dns2}`;
          // zone['network']['dns2'] = this.network_configs.dns2;
        }
        if (this.network_configs.proxy_host) {
          networkString += `&network[proxy_host]=${this.network_configs.proxy_host}`;
          // zone['network']['proxy_host'] = this.network_configs.proxy_host;
        }
        if (this.network_configs.proxy_port) {
          networkString += `&network[proxy_port]=${this.network_configs.proxy_port}`;
          // zone['network']['proxy_port'] = this.network_configs.proxy_port;
        }
        if (this.network_configs.network_config_proxy_auth_type) {
          networkString += `&network[proxy_auth_type]=${this.network_configs.network_config_proxy_auth_type.network_config_proxy_auth_type_id}`;
          // zone['network']['proxy_auth_type'] = this.network_configs.network_config_proxy_auth_type.network_config_proxy_auth_type_id;
        }
        if (this.network_configs.proxy_user) {
          networkString += `&network[proxy_user]=${this.network_configs.proxy_user}`;
          // zone['network']['proxy_user'] = this.network_configs.proxy_user;
        }
        if (this.network_configs.proxy_pass) {
          networkString += `&network[proxy_pass]=${this.network_configs.proxy_pass}`;
          // zone['network']['proxy_pass'] = this.network_configs.proxy_pass;
        }
      } else {
        networkString += '&network[type]=dhcp';
        // zone['network']['type'] = 'dhcp';
      }

      return networkString;
    },
    // Converts hour object into string for POST/PUT
    makeHoursString() {
      let hoursString = '';
      // Format hours for JSON
      for (let i = 0; i < this.hours.length; i++) {
        const { open_time } = this.hours[i];
        const { close_time } = this.hours[i];
        const row = 1 + i;

        hoursString += `&hours[${row}][open_time]=${open_time}&hours[${row}][close_time]=${close_time}`;
      }
      return hoursString;
    },
    putZone(zone) {
      if (!zone || !zone.id) {
        this.errorString = 'Error: Unable to save this zone';
        this.$wkToast(this.errorString);
        return;
      }

      let queryStringZone = Querystring.stringify(zone);
      const hoursString = this.makeHoursString();
      const networkString = this.makeNetworkConfigQueryString();

      queryStringZone = queryStringZone + hoursString + networkString;

      const self = this;
      this.$http.put(`/v2/zone/${zone.id}`, queryStringZone).then(() => {
        if (self.zoneMsa && self.zoneMsa.client_document_type_id == self.UNSIGNED_MSA_ID) {
          self.signDocument(zone);
        } else {
          self.$emit('zoneSaved', zone);
          self.clearInfo();
          self.$emit('close');
        }
      },
      (response) => {
        self.errorString = self.returnFriendlyErrors(response.data.data.fields);
        self.$wkToast(self.errorString);
      }).catch(() => {
        // console.log(response.body.data);
      });
    },
    signDocument(zone) {
      if (!this.zoneMsa || this.zoneMsa.client_document_type_id == this.SIGNED_MSA_ID) {
        return;
      }

      const docParams = {
        'relations[0][type]': 'LocationZone',
        'relations[0][id]': zone.id,
      };
      if (this.msa_signature) {
        docParams.signature = this.msa_signature;
      }

      const queryString = Querystring.stringify(docParams);
      this.$http.put(`/v2/document/${this.zoneMsa.id}/sign`, queryString).then(() => {},
        () => {
          // this.errorString = this.returnFriendlyErrors(response.body.data.fields)

        }).catch((response) => {
        console.log(response.data.data);
      });

      this.$emit('zoneSaved', zone);
      this.$emit('close');
    },
    getDayName(day_id) {
      for (const day in this.days) {
        if (day == day_id) {
          return this.days[day];
        }
      }
    },
    copyToAll() {
      const { open_time } = this.hours[0];
      const { close_time } = this.hours[0];
      const { display_open_time } = this.hours[0];
      const { display_close_time } = this.hours[0];

      for (let i = 0; i < 7; i++) {
        this.hours[i].open_time = open_time;
        this.hours[i].close_time = close_time;

        this.hours[i].display_open_time = display_open_time; // { "id": close_time, "formattedTime": display_close_time };
        this.hours[i].display_close_time = display_close_time; // { "id": close_time, "formattedTime": display_close_time };
        this.$nextTick();
      }
    },
    updateDHCPStatic(type) {
      this.network_configs.network_config_type_id = type;
    },
    setFirstMonthOfService(player_arrival_date) {
      if (!player_arrival_date) player_arrival_date = new Date();

      const date = new Date(player_arrival_date);
      const dd = date.getDate();
      const mm = String(date.getMonth() + 1);
      let newMonth = '';

      if (dd < 16) {
        newMonth = mm;
      } else if (mm == '12') {
        newMonth = '01';
      } else {
        newMonth = String(date.getMonth() + 2);
      }
      this.first_month_of_service = newMonth;
    },
    listizeErrors(e) {
      let list = "<ul style='text-align: left;margin-top:5px'>";
      for (let i = 0; i < e.length; i++) {
        list = `${list}<li>${e[i]}</li>`;
      }

      list = `${list}</ul>`;
      return list;
    },
    formatDate(unformatted_date) {
      let formattedDate = new Date(unformatted_date);
      const dd = String(formattedDate.getDate()).padStart(2, '0');
      const mm = String(formattedDate.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = formattedDate.getFullYear();

      formattedDate = `${yyyy}-${mm}-${dd}`;

      return formattedDate;
    },
    scrollToServiceAgreement() {
      const element = document.getElementById('service_agreement');
      if (!element) return;
      const top = element.offsetTop + 20;
      window.scrollTo(0, top);
    },
    setMsaForZone() {
      if (!this.locationDocuments || !this.id) return;

      const zid = this.id;
      if (this.locationDocuments[zid]) {
        let zoneDocs = this.locationDocuments[zid];

        if (!zoneDocs) { return; }

        zoneDocs = sortByKey(zoneDocs, 'upload_date').reverse();
        for (let j = 0; j < zoneDocs.length; j++) {
          if (zoneDocs[j].client_document_type_id == this.SIGNED_MSA_ID || zoneDocs[j].client_document_type_id == this.UNSIGNED_MSA_ID) {
            if (zoneDocs[j].client_document_type_id == this.SIGNED_MSA_ID) {
              this.msa_is_signed = true;
            }

            this.zoneMsa = zoneDocs[j];
            return;
          }
        }
      }
    },
    setProposalForZone() {
      if (!this.locationDocuments || !this.id) return;

      const zid = this.id;
      if (this.locationDocuments[zid]) {
        let zoneDocs = this.locationDocuments[zid];
        if (!zoneDocs) { return; }

        zoneDocs = sortByKey(zoneDocs, 'upload_date').reverse();
        for (let j = 0; j < zoneDocs.length; j++) {
          if (zoneDocs[j].client_document_type_id == this.PROPOSAL_ID) {
            this.zoneProposal = zoneDocs[j];
            return;
          }
        }
      }
    },
  },

  watch: {

    player_arrival_date() {
      this.setFirstMonthOfService(this.player_arrival_date);
    },
    errorString() {
      if (this.errorString == '' || this.errorString == null) {
        return;
      }
      const element = document.getElementById('formTopping');
      if (!element) return;
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },
    userInfo() {
      if (this.userInfo.service_options) {
        for (let i = 0; i < this.userInfo.service_options.length; i++) {
          if (this.userInfo.service_options[i].service_option_id == this.HIDE_MSA_SERVICE_OPTION_ID) {
            this.shouldHideMsa = true;
          }
          if (this.userInfo.service_options[i].service_option_id == this.HIDE_PROPOSAL_SERVICE_OPTION_ID) {
            this.shouldHideProposal = true;
          }
        }
      }
    }, // Returns the msa document for most recent signed, or unsigned, MSA
    // locationDocuments: function() {
    //     if (!this.zoneMsa) {
    //         this.setMsaForZone();
    //     }
    //     if (!this.zoneProposal) {
    //         this.setProposalForZone();
    //     }
    // },
    // id: function() {
    //     if (!this.zoneMsa) {
    //         this.setMsaForZone();
    //     }
    //     if (!this.zoneProposal) {
    //         this.setProposalForZone();
    //     }
    // },
  },
  computed: {

    disabledPastDates() {
      const plusTwoWeeks = new Date(Date.now() + 12096e5);
      const dd = plusTwoWeeks.getDate();
      const mm = plusTwoWeeks.getMonth();
      const yyyy = plusTwoWeeks.getFullYear();

      const plusTwoDays = new Date();
      plusTwoDays.setDate(plusTwoDays.getDate() + 2);
      const dd2 = plusTwoDays.getDate();
      const mm2 = plusTwoDays.getMonth();
      const yyyy2 = plusTwoDays.getFullYear();

      if (this.expedite == true) {
        return {
          to: new Date(yyyy2, mm2, dd2),
          from: plusTwoWeeks,
        };
      }
      return {
        to: new Date(yyyy, mm, dd),
      };
    },
    timeOptions() {
      const timeOptions = [];
      for (let i = 0; i < 24; i++) {
        let hours = i % 12;
        hours = hours || 12; // the hour '0' should be '12'

        if (i < 10) {
          i = `0${i}`;
        }

        const timeString = `${i}:00`;
        // let arr = { id:timeString, formattedTime: hours + "" + ampm}; // + " (" + hours + "" + ampm + ")"
        timeOptions.push(timeString);
      }
      return timeOptions;
    },
    hoursOptions() {
      const timeOptions = [];
      let i = 0;
      do {
        const d = new Date();
        d.setHours(i);
        d.setMinutes(0);
        timeOptions.push(d);
        i += 1;
      } while (i < 24);
      return timeOptions;
    },
    first_month_of_service_string() {
      if (!this.player_arrival_date) {
        return '-';
      }
      return this.first_month_of_service;
    },
  },
  components: {
    Datepicker,
  },
};
//
function sortByKey(array, key) {
  return array.sort((a, b) => {
    const x = a[key];
    const y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}
</script>

<style scoped>
.modal-dialog {
    width: auto;
    max-width: 700px;
    margin: 0 auto;
    margin-top: 50px;
}

.modal-content {
    /* width:700px;
        margin:0 auto; */
    background: #666;
    color: white;
    height: 700px;
    max-height: 100vh;
    overflow:hidden;
    padding:0px 2px 20px 10px;
}

.modal-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
}

.onboarding-container {
    text-align: left;
    width: 100%;
    margin: 0 auto;
    overflow: scroll;
    height:100%;
}

.close-modal {
    position: absolute;
    top: 0px;
    right: 10px;
    cursor: pointer;
    text-align: right;
    width: 20px;
    height: 20px;
}

.close-modal.isTpg {
    color: black;
}

/* .modal {
  position: absolute;
  float: left;
  left: 50%;
  transform: translateX(-50%);

    width:700px;
} */

.modal-content.isTpg {
    background: #efefef;
}

.datepicker .cell.day {
    text-indent: .8em;
}

textarea {
    width: 100%;
    border-radius: 5px;
    color: black;
    border: 0px;
}

.copyToAllSmall {
    position: absolute;
    right: 420px;
    top: 5px;
    font-size: 16px;
}

.dropdown-menu li a {
    color: black;
    text-decoration: none;
    background-color: #ffffff;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
.onboarding-container fieldset {
border-color: #fff;
border-width: 0px;
border-style: solid;
padding: 10px;
margin: 0;
margin-top: 35px;
background-color: rgba(125, 125, 125, 0.5);
border-radius: 5px;
padding: 20px;
}
.onboarding-container fieldset:first-child {
margin-top:0px;
}
.onboarding-container input[type="text"] {
    border: 0px solid #ccc;
    background: #fff;
    color: #000;
    border-radius: 5px;
    width: 100%;
    height: 30px;
    font-weight: normal;
}

.close-modal {
    top: 0px;
}

input[type='checkbox'] {
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border: 1px solid white;
    border-radius: 50%;
    outline: none;
    transition: .3s;
}

input[type='checkbox']:hover {
    box-shadow: 0 0 5px 0px #fff inset;
}

input[type='checkbox']:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
}

input[type='checkbox']:checked:before {
    background: yellow;
}

.close-modal.isTpg {
    color: black;
}

.modal-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
}

.onboarding-container.isTpg fieldset {
    background-color: transparent;
    border: 0px solid rgb(172, 172, 172);
}

.form-blurb {
    text-align: left;
    padding: 5px 17px;
    border: 0px solid #666;
    border-radius: 5px;
    font-size: smaller;
    font-style: italic;
}

.form-desc {
    text-align: left;
    padding: 10px 10px;
    border: 1px solid #666;
    border-radius: 5px;
    font-size: smaller;
    font-style: italic;
}

.form-blurb.isTpg {
    border: 1px solid rgb(172, 172, 172);
}

.modal-title {
    margin-bottom: 10px;
    border-bottom: 1px solid #666;
}

fieldset .row {
    padding-bottom: 15px;
}

.hours-row {
    margin-bottom: 5px;
    clear: both;
    height: 40px;
}

.section-header {
    /* border-top: 1px solid rgb(112, 112, 112); */
    font-size: 20px;
    width: 100%;
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
    padding: 10px;
    margin-top: 0px;
}

.onboarding-container input[type='radio'] {
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border: 1px solid white;
    border-radius: 50%;
    outline: none;
    transition: .3s;
    background: #666;
}

.onboarding-container.isTpg input[type='radio'] {
    border: 1px solid #ccc;
    background: white;
}

.onboarding-container input[type='radio']:hover {
    box-shadow: 0 0 5px 0px #fff inset;
}

.onboarding-container input[type='radio']:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
}

.form-check input[type='radio']:checked:before {
    background: yellow;
}

.form-check.isTpg input[type='radio']:checked:before {
    background: rgba(1, 172, 129, 1);
    ;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

:deep(.popper) {
    background: #363636;
    padding: 20px;
    border-radius: 20px;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
  }

  :deep(.popper #arrow::before) {
    background: #363636;
  }

  :deep(.popper:hover),
  :deep(.popper:hover > #arrow::before) {
    background: #363636;
  }
</style>
